// import { Avatar, Box, Card, CardContent, Divider, Grid, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material'
// import React, { useEffect, useState } from 'react'
// import profile_img from "../../../Assets/profile_img.jpg"
// import { FiUsers } from 'react-icons/fi';
// // import NotificationAllmuiTab from './NotificationAllmuiTab'

// import { IoMdTransgender } from "react-icons/io";
// import { MdOutlineDateRange } from "react-icons/md";
// import { MdOutlineEmail } from "react-icons/md";
// import { IoCallOutline } from "react-icons/io5";
// import { MdOutlineMyLocation } from "react-icons/md";
// import { MdOutlineAddLocation } from "react-icons/md";
// import { MdOutlineLocationOn } from "react-icons/md";
// import { GrMapLocation } from "react-icons/gr";
// import { FaUserGraduate } from "react-icons/fa";
// import { TiLocationArrowOutline } from "react-icons/ti";
// import { MdOutlineBatchPrediction } from "react-icons/md";
// import { SiAndroidstudio } from "react-icons/si";
// import { CgWebsite } from "react-icons/cg";
// import { MdEdit } from "react-icons/md";


// import { IconButton, Stack } from '@mui/material';
// import { Add, Edit, Delete, EmojiEvents, Folder, EditNoteSharp } from '@mui/icons-material';
// import EditProfileModal from './EditProfileModal';
// import AwardCreateModal from './AwardCreateModal';
// import { useDispatch } from 'react-redux';
// import actions from '../../../ReduxStore/actions';

// const InfoCard = ({ icon, title, entries, handleModalOpen }) => (
//     <Card sx={{ borderRadius: 3, p: 2 }}>
//         <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
//             <Stack direction="row" alignItems="center" spacing={1}>
//                 {icon}
//                 <Typography variant="h6" fontWeight="bold">{title}</Typography>
//             </Stack>
//             <IconButton color="primary" size="small" onClick={handleModalOpen}>
//                 <Add />
//             </IconButton>
//         </Stack>
//         <Box>
//             {entries.map((entry, index) => (
//                 <Box key={index} mb={2}>
//                     <Typography variant="subtitle1" fontWeight="bold">
//                         {index + 1}. {entry.title}
//                     </Typography>
//                     <Typography color="error" fontWeight="medium">
//                         {entry.subtitle}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary" gutterBottom>
//                         @{entry.org} , {entry.date}
//                     </Typography>
//                     <Stack direction="row" spacing={1}>
//                         <IconButton color="primary" size="small">
//                             <Edit />
//                         </IconButton>
//                         <IconButton color="primary" size="small">
//                             <Delete />
//                         </IconButton>
//                     </Stack>
//                 </Box>
//             ))}
//         </Box>
//     </Card>
// );

// const SectionCard = ({ title, children }) => (
//     <Card sx={{ mb: 2 }}>
//         <CardContent>
//             <Typography variant="h6" gutterBottom>
//                 {title}
//             </Typography>
//             <Divider sx={{ marginBottom: 2 }} />

//             {children}
//         </CardContent>
//     </Card>
// );

// const AwardsSection = ({ awards }) => (
//     <SectionCard title="Awards">
//         <ul style={{ paddingLeft: "1rem", margin: 0 }}>
//             {awards?.length > 0 ? (

//                 awards.map((award, idx) => (
//                     <li key={idx} style={{ marginBottom: "10px" }}>
//                         <Typography variant="body2">{award?.title}-{award?.organization} ({award?.year})</Typography>
//                         <Typography variant="body1">{award?.remarks}</Typography>

//                     </li>
//                 ))
//             ) : (
//                 <Typography color="error">Award details not availabe!
//                 </Typography>

//             )}
//         </ul>
//     </SectionCard>
// );

// const user = {
//     name: "Khushi Bhargava",
//     gender: "Female",
//     dob: "31/08/2000",
//     email: "sudhir_bhargava@hotmail.com",
//     mobile: "9818171714",
//     permanentCity: "DELHI",
//     yearOfCompletion: "2022",
//     campus: "MUMBAI",
//     batch: "2018-2022",
//     course: "B. Des Textile Design",
//     views: 85,
//     connections: 0,
//     image: profile_img
// };



// const userInfoRows = [
//     { label: 'Name', icon: FiUsers, value: user.name },
//     { label: 'Gender', icon: IoMdTransgender, value: user.gender },
//     { label: 'Date of Birth', icon: MdOutlineDateRange, value: user.dob },
//     { label: 'Email', icon: MdOutlineEmail, value: user.email },
//     { label: 'Mobile', icon: IoCallOutline, value: user.mobile },
//     { label: 'Present Address', icon: MdOutlineMyLocation, value: user.presentAddress },

//     { label: 'Present City', icon: MdOutlineAddLocation, value: user.presentCity },
//     { label: 'Permanent Address', icon: MdOutlineLocationOn, value: user.permanentAddress },

//     { label: 'Permanent City', icon: GrMapLocation, value: user.permanentCity },
//     { label: 'Year of Completion', icon: FaUserGraduate, value: user.yearOfCompletion },
//     { label: 'Campus', icon: TiLocationArrowOutline, value: user.campus },
//     { label: 'Batch', icon: MdOutlineBatchPrediction, value: user.batch },
//     { label: 'Course', icon: SiAndroidstudio, value: user.course },
//     { label: 'Website', icon: CgWebsite, value: user.website },
// ];

// const InfoTable = ({ rows }) => (
//     <Table>
//         <TableBody>
//             {rows.map(({ label, value, icon: Icon }, index) => (
//                 <TableRow key={index}>
//                     <TableCell sx={{
//                         width: '30%', whiteSpace: "nowrap",
//                         textOverflow: "ellipsis"
//                     }}>
//                         < Box sx={{ display: "flex", alignItems: "center" }}>
//                             <Icon style={{ marginRight: "5px" }} />
//                             <Typography variant="body2">{label}</Typography>
//                         </Box>
//                     </TableCell>
//                     <TableCell>
//                         <Typography variant="subtitle1">{value || '-'}</Typography>
//                     </TableCell>
//                 </TableRow>
//             ))}
//         </TableBody >
//     </Table >
// );

// const EditProfilePage = () => {
//     const [editModalOpen, setEditModalOpen] = useState(false)
//     const handleEditModalOpen = () => {
//         setEditModalOpen(true)
//     }
//     const handleEditModalClose = () => {
//         setEditModalOpen(false)
//     }
//     const [awardModalOpen, setAwardModalOpen] = useState(false)
//     const handleAwardModalOpen = () => {
//         setAwardModalOpen(true)
//     }
//     const handleAwardModalClose = () => {
//         setAwardModalOpen(false)
//     }
//     const dispatch = useDispatch()
//     const sessionUserId = sessionStorage.getItem("userId")
//     const [awardData, setAwardData] = useState([])
//     useEffect(() => {


//         const fetchData = async () => {
//             const data1 = {
//                 data: {},
//                 method: "get",
//                 apiName: `getAwardsByUserId/${sessionUserId}`,
//             };
//             const response = await dispatch(actions.GETAWARDSBYUSRID(data1));

//             console.log(response, "responseresponse")

//             if (response?.payload?.message === "Awards fetched successfully") {
//                 console.log("hiiiiiiiiiiiiiiii")

//                 const responseData = response?.payload?.data?.map((data) => ({
//                     // user_id: data?.user_id,
//                     id: data?.award_date,
//                     award_name: data?.award_name,
//                     certificate_file: data?.certificate_file,
//                     description: data?.description,
//                     issued_by: data?.issued_by,
//                     title: data?.title,
//                     award_date: data?.award_date



//                 }))
//                 setAwardData(responseData)

//             }
//         }
//         fetchData()


//     }, [])


//     const cygnusaEvents = [
//         {
//             heading: "Tech Fest: Innovators Ignite",
//             date: "05/04/2023 - 30/04/2023",
//             content: "Join us for a day of creativity and innovation at the annual Tech Fest, featuring coding competitions, workshops, and expert talks! 🚀"
//         },
//         {
//             heading: "Cultural Carnival: Fusion Fiesta",
//             date: "24/05/2023 - 24/05/2023",
//             content: "Celebrate diversity with music, dance, and art at our vibrant Cultural Carnival. Unleash your talent and enjoy the magic of unity! 🎭🎶"
//         },
//         {
//             heading: "Sports Extravaganza: Champions Unite",
//             date: "01/06/2023 - 01/06/2023",
//             content: "Gear up for adrenaline-pumping action at the Sports Extravaganza. Compete, cheer, and make memories on the field! 🏅⚽"
//         },
//     ]

//     const awardEntries = [{
//         title: 'LifeTime Achievement Award',
//         subtitle: 'Education and Research',
//         org: 'Avishkar Foundation',
//         date: '2020'
//     },
//     {
//         title: 'LifeTime Achievement Award',
//         subtitle: 'Education and Research',
//         org: 'Avishkar Foundation',
//         date: '2020'
//     }];

//     const projectEntries = [{
//         title: 'Workshop on Hand Embroidery to train 1000 members of cooperative societies',
//         subtitle: 'Coordinator',
//         org: 'Directorate of Hand looms and Textiles - Govt. of',
//         date: '10.11.2010 to 31.12.2010'
//     }];




//     return (

//         <Grid container spacing={2} sx={{
//             backgroundColor: "rgb(245, 245, 245)",
//             // minHeight: "1    00vh",
//             pt: 3,
//             px: 5,
//             width: "100%",
//             pb: 3
//         }}>
//             <Grid item size={{ md: 3, xs: 12, sm: 12 }} sx={{

//                 borderRadius: "10px",
//                 textAlign: "center",
//                 // p: 3,
//                 // maxHeight:"90vh"

//             }}  >
//                 <Card sx={{ textAlign: "center", mb: 2 }}>
//                     <CardContent>

//                         <Box sx={{
//                             width: "100%",
//                             display: "flex",
//                             justifyContent: "center"
//                         }}>
//                             <Avatar
//                                 src={profile_img}
//                                 sx={{
//                                     // bgcolor: "white",
//                                     border: "1px solid white",
//                                     height: "200px", width: "80%",
//                                     // "& .MuiAvatar-img": {
//                                     //     objectFit: ""
//                                     // }
//                                 }}
//                             >
//                             </Avatar>

//                         </Box>

//                         <Typography variant="h6">
//                             Preethi Sagar
//                         </Typography>
//                         <Typography mt={2} variant='h5'>
//                             Professor
//                         </Typography>
//                         <Typography mb={3} variant='h5'>
//                             National Institute of Fashion Technology
//                         </Typography>
//                         <Divider />
//                         <Typography mt={2} sx={{
//                             color: "#1976d2",
//                             fontSize: "17px",
//                             fontWeight: 700
//                         }}>
//                             6
//                         </Typography>
//                         <Typography mb={2}>
//                             Connections
//                         </Typography>
//                         <Divider />
//                         <Typography variant='body1'>
//                             Logout
//                         </Typography>
//                     </CardContent>
//                 </Card>
//             </Grid>



//             <Grid item size={{ md: 6, xs: 12, sm: 12 }} sx={{
//                 // backgroundColor: "white",
//                 borderRadius: "10px",

//             }} >
//                 <Box sx={{
//                     // backgroundColor:"white"
//                 }}>
//                     {/* <NotificationAllmuiTab /> */}
//                     <Card>
//                         <CardContent>
//                             <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                                 <Typography variant="h6" gutterBottom>
//                                     Personal Details
//                                 </Typography>
//                                 <Typography variant='subtitle2' onClick={handleEditModalOpen} sx={{ cursor: "pointer" }}>
//                                     <MdEdit /> Edit
//                                 </Typography>
//                             </Box>


//                             <InfoTable rows={userInfoRows} />

//                         </CardContent>

//                     </Card>
//                 </Box>

//             </Grid>

//             <Grid item size={{ md: 3, xs: 12, sm: 12 }} sx={{
//                 backgroundColor: "white",
//                 borderRadius: "10px",
//                 p: 3

//             }}>
//                 {/* <Box sx={{ p: 4 }}> */}
//                 <Grid container spacing={3}>
//                     <Grid item xs={12} md={6}>
//                         <AwardsSection title="Awards" icon={<EmojiEvents />} entries={awardEntries} handleModalOpen={handleAwardModalOpen} />
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                         <InfoCard title="Awards" icon={<EmojiEvents />} entries={awardEntries} handleModalOpen={handleAwardModalOpen} />
//                     </Grid>
//                     <Grid item xs={12} md={6}>
//                         <InfoCard title="Projects" icon={<Folder />} entries={projectEntries} />
//                     </Grid>
//                 </Grid>
//                 {/* </Box> */}

//             </Grid>
//             <EditProfileModal
//                 open={editModalOpen}
//                 onClose={handleEditModalClose}
//             />
//             <AwardCreateModal
//                 open={awardModalOpen}
//                 onClose={handleAwardModalClose}
//             />

//         </Grid>

//     )
// }

// export default EditProfilePage

import { Avatar, Box, Card, CardContent, Dialog, DialogTitle, Divider, Grid, Paper, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import profile_img from "../../../Assets/profile_img.jpg"
import { FiUsers } from 'react-icons/fi';
// import NotificationAllmuiTab from './NotificationAllmuiTab'

import { IoMdTransgender } from "react-icons/io";
import { MdOutlineDateRange } from "react-icons/md";
import { MdOutlineEmail } from "react-icons/md";
import { IoCallOutline, IoCloseCircleOutline } from "react-icons/io5";
import { MdOutlineMyLocation } from "react-icons/md";
import { MdOutlineAddLocation } from "react-icons/md";
import { MdOutlineLocationOn } from "react-icons/md";
import { GrMapLocation } from "react-icons/gr";
import { FaUserGraduate } from "react-icons/fa";
import { TiLocationArrowOutline } from "react-icons/ti";
import { MdOutlineBatchPrediction } from "react-icons/md";
import { SiAndroidstudio } from "react-icons/si";
import { CgWebsite } from "react-icons/cg";
import { MdEdit } from "react-icons/md";


import { IconButton, Stack } from '@mui/material';
import { Add, Edit, Delete, EmojiEvents, Folder, EditNoteSharp } from '@mui/icons-material';
import EditProfileModal from './EditProfileModal';
import AwardCreateModal from './AwardCreateModal';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../ReduxStore/actions';
import { toast, ToastContainer } from 'react-toastify';
import EducationCreateModal from './EducationCreateModal';
import ExperienceCreateModal from './ExperienceCreateModal';
import ProjectsCreateModal from './ProjectsCreateModal';
import SkillsCreateModal from './SkillsCreateModal';
import { useNavigate } from 'react-router-dom';
import { adminUrl } from '../../../constants';
import { BsEye } from 'react-icons/bs';
import { FaEye } from 'react-icons/fa6';

const InfoCard = ({ icon, title, entries, handleModalOpen }) => (
    <Card sx={{ borderRadius: 3, p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
            <Stack direction="row" alignItems="center" spacing={1}>
                {icon}
                <Typography variant="h6" fontWeight="bold">{title}</Typography>
            </Stack>
            <IconButton color="primary" size="small" onClick={handleModalOpen}>
                <Add style={{ color: "var(--main-color)" }} />
            </IconButton>
        </Stack>
        <Box>
            {entries.map((entry, index) => (
                <Box key={index} mb={2}>
                    <Typography variant="subtitle1" fontWeight="bold">
                        {index + 1}. {entry.title}
                    </Typography>
                    <Typography color="error" fontWeight="medium">
                        {entry.subtitle}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        @{entry.org} , {entry.date}
                    </Typography>
                    <Stack direction="row" spacing={1}>
                        <IconButton color="primary" size="small">
                            <Edit />
                        </IconButton>
                        <IconButton color="primary" size="small">
                            <Delete />
                        </IconButton>
                    </Stack>
                </Box>
            ))}
        </Box>
    </Card>
);

const SectionCard = ({ title, children, handleModalOpen }) => (
    <Card sx={{ mb: 2 }}>
        <CardContent>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="h6" gutterBottom>
                    {title}
                </Typography>
                <IconButton color="primary" size="small" onClick={handleModalOpen}>
                    <Add style={{ color: "var(--main-color)" }} />
                </IconButton>
            </Box>
            <Divider sx={{ marginBottom: 2 }} />

            {children}
        </CardContent>
    </Card>
);

const AwardsSection = ({ awards, handleModalOpen, handleAwardEditOpen, handleAwardelete, handleImageClick }) => (
    <SectionCard title="Awards" handleModalOpen={handleModalOpen}>
        <ul style={{ paddingLeft: "1rem", margin: 0 }}>
            {awards?.length > 0 ? (



                awards.map((award, idx) => (
                    <li key={idx} style={{ marginBottom: "10px" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" sx={{ fontSize: "16px" }}>{award?.award_name}</Typography>
                            <Stack direction="row" spacing={1}>
                                <IconButton color="primary" size="small" sx={{ fontSize: "12px" }}
                                    onClick={() => {
                                        handleAwardEditOpen(award?.id)
                                    }}>
                                    <Edit sx={{ fontSize: "12px", color: "gray" }} />
                                </IconButton>
                                <IconButton color="primary" size="small"
                                    onClick={() => {
                                        handleAwardelete(award?.id)
                                    }}>
                                    <Delete sx={{ fontSize: "14px", color: "gray" }} />
                                </IconButton>

                            </Stack>
                        </Box>
                        <Typography variant="subtitle1" sx={{ fontSize: "15px" }}>@{award?.issued_by} - <span style={{ fontSize: "12px", color: "gray" }}>{award?.award_date}</span></Typography>


                        <Typography variant="subtitle1" sx={{ fontSize: "14px" }}>{award?.feild}</Typography>
                        {/* <Typography variant="body1" sx={{ fontSize: "12px" }}>{award?.award_date}</Typography> */}


                        <Typography variant="body1">{award?.description}</Typography>
                        {award?.certificate_file &&
                            <Box sx={{ border: "1px solid #ddd8d8", mt: 2 }}>
                                <Box
                                    onClick={() => {
                                        handleImageClick(award?.certificate_file)

                                    }}
                                    component="img"
                                    src={`${adminUrl}${award?.certificate_file}`}
                                    sx={{
                                        height: "100px",
                                        width: "100%",
                                        cursor: "pointer"


                                    }}
                                >

                                </Box>
                            </Box>
                        }


                    </li>
                ))
            ) : (
                <Typography color="error">Award details not availabe!
                </Typography>

            )}
        </ul>
    </SectionCard>
);




const EducationSection = ({ educationData, handleEducationModalOpen, handleEducationEditOpen, handleEducationdelete, handleImageClick }) => (
    <SectionCard title="Education" handleModalOpen={handleEducationModalOpen}>
        <ul style={{ paddingLeft: "1rem", margin: 0 }}>
            {
                educationData?.length ? (
                    educationData.map((data, idx) => (
                        <li key={idx} style={{ marginBottom: "10px" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Typography variant="h6" sx={{ fontSize: "16px" }}>{data?.institute_name}</Typography>
                                <Stack direction="row" spacing={1}>
                                    <IconButton color="primary" size="small" sx={{ fontSize: "12px" }}
                                        onClick={() => {
                                            handleEducationEditOpen(data?.id)
                                        }}>
                                        <Edit sx={{ fontSize: "12px", color: "gray" }} />
                                    </IconButton>
                                    <IconButton color="primary" size="small"
                                        onClick={() => {
                                            handleEducationdelete(data?.id)
                                        }}>
                                        <Delete sx={{ fontSize: "14px", color: "gray" }} />
                                    </IconButton>
                                </Stack>
                            </Box>
                            <Box key={idx} mb={1.5}>
                                <Typography variant="subtitle1" sx={{ fontSize: "15px" }}>{data?.degree} {data?.field_of_study}</Typography>
                                <Typography variant="subtitle1" sx={{ fontSize: "14px" }}>{data?.grade} CGPA</Typography>

                                <Typography variant="body1"
                                // fontSize="14px" 
                                >
                                    {data?.start_date} to {data?.end_date}
                                </Typography>
                                <Typography variant="body1">{data?.description}</Typography>
                            </Box>
                            {data?.certificate_file &&
                                <Box sx={{ border: "1px solid #ddd8d8", mt: 2 }}>
                                    <Box
                                        onClick={() => {
                                            handleImageClick(data?.certificate_file)

                                        }}
                                        component="img"
                                        src={`${adminUrl}${data?.certificate_file}`}
                                        sx={{
                                            height: "100px",
                                            width: "100%",
                                            cursor: "pointer"


                                        }}
                                    >

                                    </Box>
                                </Box>
                            }

                        </li>

                    ))
                ) : (
                    <Typography color="error">Education details not availabe!
                    </Typography>

                )
            }
        </ul>
    </SectionCard>
)


const ExperienceSection = ({ experienceData, handleExperiencEditOpen, handleExperienceModalOpen, handleExericncedelete, handleImageClick }) => (
    <SectionCard title="Experience" handleModalOpen={handleExperienceModalOpen}>
        <ul style={{ paddingLeft: "1rem", margin: 0 }}>
            {
                experienceData?.length ? (
                    experienceData.map((data, idx) => (
                        <li key={idx} style={{ marginBottom: "10px" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Typography variant="h6" sx={{ fontSize: "16px" }}>{data?.job_title}</Typography>
                                <Stack direction="row" spacing={1}>
                                    <IconButton color="primary" size="small" sx={{ fontSize: "12px" }}
                                        onClick={() => {
                                            handleExperiencEditOpen(data?.id)
                                        }}>
                                        <Edit sx={{ fontSize: "12px", color: "gray" }} />
                                    </IconButton>
                                    <IconButton color="primary" size="small"
                                        onClick={() => {
                                            handleExericncedelete(data?.id)
                                        }}>
                                        <Delete sx={{ fontSize: "14px", color: "gray" }} />
                                    </IconButton>
                                </Stack>
                            </Box>
                            <Box key={idx} mb={1.5}>
                                <Typography variant="subtitle1" sx={{ fontSize: "15px" }}>{data?.company_name} - {data?.location}</Typography>
                                <Typography variant="subtitle1" sx={{ fontSize: "14px" }}>{data?.employment_type}</Typography>

                                <Typography variant="body1"
                                // fontSize="14px" 
                                >
                                    {data?.start_date} to {data?.end_date}
                                </Typography>
                                <Typography variant="body1">
                                    Skills used: {data?.skills_used?.join(' , ')}
                                </Typography>

                                <Typography variant="body1">{data?.description}</Typography>
                            </Box>
                            {data?.certificate_file &&
                                <Box sx={{ border: "1px solid #ddd8d8", mt: 2 }}>
                                    <Box
                                        onClick={() => {
                                            handleImageClick(data?.certificate_file)

                                        }}
                                        component="img"
                                        src={`${adminUrl}${data?.certificate_file}`}
                                        sx={{
                                            height: "100px",
                                            width: "100%",
                                            cursor: "pointer"


                                        }}
                                    >

                                    </Box>
                                </Box>
                            }

                        </li>

                    ))
                ) : (
                    <Typography color="error">Experience details not availabe!
                    </Typography>

                )
            }
        </ul>
    </SectionCard>
)

const ProjectsSection = ({ projectData, handleProjectnModalOpen, handleProjectEditOpen, handlePrjectdelete, handleImageClick }) => (
    <SectionCard title="Projects" handleModalOpen={handleProjectnModalOpen}>
        <ul style={{ paddingLeft: "1rem", margin: 0 }}>

            {projectData?.length > 0 ? (
                projectData.map((project, idx) => (
                    <li key={idx} mb={1}>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="body2">{project?.project_title}</Typography>
                            {/* <Typography variant="subtitle1" fontSize="14px">{project.start_date} to {project.end_date}</Typography> */}
                            <Stack direction="row" spacing={1}>
                                <IconButton color="primary" size="small" sx={{ fontSize: "12px" }}
                                    onClick={() => {
                                        handleProjectEditOpen(project?.id)
                                    }}>
                                    <Edit sx={{ fontSize: "12px", color: "gray" }} />
                                </IconButton>
                                <IconButton color="primary" size="small"
                                    onClick={() => {
                                        handleImageClick(project?.id)
                                    }}>
                                    <Delete sx={{ fontSize: "14px", color: "gray" }} />
                                </IconButton>

                            </Stack>
                        </Box>
                        <Typography variant="subtitle1" sx={{ fontSize: "15px" }}>{project?.role}</Typography>

                        <Typography variant="body1" fontSize="14px">{project?.start_date} to {project?.end_date}</Typography>
                        <Typography variant="body1">
                            Skills used: {project?.skills?.join(' , ')}
                        </Typography>
                        <Typography
                            variant="body1"

                        >
                            {project?.description}
                        </Typography>
                        {project?.certificate_file &&
                            <Box sx={{ border: "1px solid #ddd8d8", mt: 2 }}>
                                <Box
                                    onClick={() => {
                                        handleImageClick(project?.certificate_file)

                                    }}
                                    component="img"
                                    src={`${adminUrl}${project?.certificate_file}`}
                                    sx={{
                                        height: "100px",
                                        width: "100%",
                                        cursor: "pointer"


                                    }}
                                >

                                </Box>
                            </Box>
                        }

                    </li>
                ))
            ) : (
                <Typography color="error">Project details not availabe!</Typography>

            )}
        </ul>
    </SectionCard>
);


// skills

const SkillsSection = ({ skillsData, handleSKillsModalOpen }) => (
    <SectionCard title="Skills & Endorsements" handleModalOpen={handleSKillsModalOpen}>
        <Stack direction="row" spacing={1} flexWrap="wrap">
            <Box
                sx={{
                    display: "flex",
                    // justifyContent: "space-between", // or "flex-start" if you want them to align without extra spacing
                    flexWrap: "wrap", // optional, if you want them to wrap on smaller screens
                    gap: 2, // optional, for consistent spacing between items
                    mt: 2,
                }}
            >
                {skillsData?.length > 0 ? (

                    skillsData?.map((skill, idx) => (
                        <Paper
                            key={idx}
                            elevation={1}
                            sx={{ px: 2, py: 0.2, borderRadius:20, background: "#e5e5e5" }}
                        >
                            <Typography variant="body1" color='black'>{skill}</Typography>
                        </Paper>
                    ))

                ) : (
                    // <Typography variant="error">no skills available</Typography>
                    <Typography color="error">Skill details not availabe!</Typography>


                )}
            </Box>
        </Stack>
    </SectionCard>
);


const user = {
    name: "Khushi Bhargava",
    gender: "Female",
    dob: "31/08/2000",
    email: "sudhir_bhargava@hotmail.com",
    mobile: "9818171714",
    permanentCity: "DELHI",
    yearOfCompletion: "2022",
    campus: "MUMBAI",
    batch: "2018-2022",
    course: "B. Des Textile Design",
    views: 85,
    connections: 0,
    image: profile_img
};



// const userInfoRows = [
//     { label: 'Name', icon: FiUsers, value: user.name },
//     { label: 'Gender', icon: IoMdTransgender, value: user.gender },
//     { label: 'Date of Birth', icon: MdOutlineDateRange, value: user.dob },
//     { label: 'Email', icon: MdOutlineEmail, value: user.email },
//     { label: 'Mobile', icon: IoCallOutline, value: user.mobile },
//     { label: 'Present Address', icon: MdOutlineMyLocation, value: user.presentAddress },

//     { label: 'Present City', icon: MdOutlineAddLocation, value: user.presentCity },
//     { label: 'Permanent Address', icon: MdOutlineLocationOn, value: user.permanentAddress },

//     { label: 'Permanent City', icon: GrMapLocation, value: user.permanentCity },
//     { label: 'Year of Completion', icon: FaUserGraduate, value: user.yearOfCompletion },
//     { label: 'Campus', icon: TiLocationArrowOutline, value: user.campus },
//     { label: 'Batch', icon: MdOutlineBatchPrediction, value: user.batch },
//     { label: 'Course', icon: SiAndroidstudio, value: user.course },
//     { label: 'Website', icon: CgWebsite, value: user.website },
// ];

const InfoTable = ({ rows }) => (
    <Table>
        <TableBody>
            {rows.map(({ label, value, icon: Icon }, index) => (
                <TableRow key={index}>
                    <TableCell sx={{
                        width:{md:'30%'}, 
                        whiteSpace: {md:"nowrap"},
                        textOverflow: {md:"ellipsis"}
                    }}>
                        < Box sx={{ display: "flex", alignItems: "center" }}>
                            <Icon style={{ marginRight: "5px" }} />
                            <Typography variant="body2">{label}</Typography>
                        </Box>
                    </TableCell>
                    <TableCell>
                        <Typography variant="subtitle1">{value || '-'}</Typography>
                    </TableCell>
                </TableRow>
            ))}
        </TableBody >
    </Table >
);

const EditProfilePage = () => {
    // image prrview

    // const [openPreview, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [previewOpen, setPreviewOpen] = useState(false);

    const handleImageClick = (imageUrl) => {
        setPreviewImage(imageUrl);
        setPreviewOpen(true);
    };

    const handleClosePreview = () => {
        setPreviewOpen(false);
        setPreviewImage("");
    };
    // ---------------------------------------


    const [editModalOpen, setEditModalOpen] = useState(false)
    const [uploadedFile, setUploadedFile] = useState(null);
    const navigate = useNavigate()

    const handleEditModalOpen = () => {
        setEditModalOpen(true)
    }
    const handleEditModalClose = () => {
        setEditModalOpen(false)
    }
    const [awardModalOpen, setAwardModalOpen] = useState(false)
    const handleAwardModalOpen = () => {
        setAwardModalOpen(true)
    }
    const handleAwardModalClose = () => {
        setAwardModalOpen(false)
    }

    // Experience
    const [experienceModalOpen, setExperienceModalOpen] = useState(false)
    const handleExperienceModalOpen = () => {
        setExperienceModalOpen(true)
    }
    const handleExperienceModalClose = () => {
        setExperienceModalOpen(false)
    }

    // educatiom
    const [educationModalOpen, setEducationModalOpen] = useState(false)
    const handleEducationModalOpen = () => {
        setEducationModalOpen(true)
    }
    const handleEducationModalClose = () => {
        setEducationModalOpen(false)
    }



    // project
    const [projectModalOpen, setProjectModalOpen] = useState(false)
    const handleProjectnModalOpen = () => {
        setProjectModalOpen(true)
    }
    const handleProjectModalClose = () => {
        setProjectModalOpen(false)
    }


    // SKills Modal open
    const [skillsModalOpen, setSkillsModalOpen] = useState(false)
    const handleSKillsModalOpen = () => {
        setSkillsModalOpen(true)
    }
    const handleSkillsModalClose = () => {
        setSkillsModalOpen(false)
    }

    // -------------------------


    const dispatch = useDispatch()
    const sessionUserId = sessionStorage.getItem("userId")
    // set award data
    const [awardData, setAwardData] = useState([])
    // set education data
    const [educationData, setEducationData] = useState([])
    const [experienceData, setExperienceData] = useState([])
    const [projectData, setProjectData] = useState([])



    const { deleteAward } = useSelector(state => state?.deleteAward);
    const { getAwardById } = useSelector(state => state?.getAwardById);
    const { createAward } = useSelector(state => state?.createAward);
    console.log(getAwardById, "getAwardById 111")
    const { updateAward } = useSelector(state => state?.updateAward);




    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getAwardsByUserId/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETAWARDSBYUSRID(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "Awards fetched successfully") {
                console.log("hiiiiiiiiiiiiiiii")

                const responseData = response?.payload?.data?.map((data) => ({
                    // user_id: data?.user_id,
                    id: data?.award_id,
                    award_name: data?.award_name,
                    certificate_file: data?.certificate_file,
                    description: data?.description,
                    issued_by: data?.issued_by,
                    feild: data?.title,
                    award_date: data?.award_date



                }))
                setAwardData(responseData)

            }
        }
        fetchData()


    }, [deleteAward, createAward, updateAward])

    // Education
    const { createEducation } = useSelector(state => state?.createEducation);
    const { updateEducation } = useSelector(state => state?.updateEducation);
    const { deleteEducation } = useSelector(state => state?.deleteEducation);


    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `usergetEducationsByUserId/${sessionUserId}`,
            };
            const response = await dispatch(actions.USERGETEDUCATIONSBYUSERID(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "Educations fetched for user.") {
                console.log("hiiiiiiiiiiiiiiii")

                const responseData = response?.payload?.data?.map((data) => ({
                    // user_id: data?.user_id,
                    id: data?.education_id,
                    institute_name: data?.institute_name,
                    certificate_file: data?.certificate_file,

                    degree: data?.degree,
                    field_of_study: data?.field_of_study,

                    start_date: data?.start_date,
                    end_date: data?.end_date,
                    grade: data?.grade,
                    extra_curricular: data?.extra_curricular,
                    description: data?.description,




                }))
                setEducationData(responseData)

            }
        }
        fetchData()


    }, [createEducation, updateEducation, deleteEducation])

    const [awardEditData, setAwardEditData] = useState(null)
    const [educationEditData, setEducationEditData] = useState(null)
    const [experienceEditData, setExperienceEditData] = useState(null)
    const [projectEditData, setProjectEditData] = useState(null)



    //  get by award by id
    const handleAwardEditOpen = async (id) => {
        const data1 = {
            data: {},
            method: "get",
            apiName: `getAwardById/${id}`,
        };
        const response = await dispatch(actions.GETAWARDBYID(data1));

        if (response?.payload?.message === "Award fetched successfully") {
            setAwardEditData(response?.payload?.data)
            handleAwardModalOpen()


        }




    }

    //  delete by award by id

    const handleAwardelete = async (id) => {

        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteAward/${id}`,
        };
        const response = await dispatch(actions.DELETEAWARD(data1));
        console.log(response, "response")
        if (response?.payload?.message === "Award deleted successfully") {
            toast.success("Award deleted successfully")
        } else {
            toast.error(response?.payload?.message)
        }



    }


    // get by education by id
    const handleEducationEditOpen = async (id) => {
        const data1 = {
            data: {},
            method: "get",
            apiName: `getEducationById/${id}`,
        };
        const response = await dispatch(actions.GETEDUCATIONBYID(data1));

        if (response?.payload?.message === "Education fetched successfully.") {
            setEducationEditData(response?.payload?.data)
            setUploadedFile(
                {
                    fileUrl: response?.payload?.data?.certificate_file,
                    type: "img", // ensure this is the expected type
                    progress: 100,
                }
            )
            handleEducationModalOpen()


        }




    }

    //  delete by award by id

    const handleEducationdelete = async (id) => {

        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteEducation/${id}`,
        };
        const response = await dispatch(actions.DELETEEDUCATION(data1));
        console.log(response, "response")
        if (response?.payload?.message === "Education deleted.") {
            toast.success("Education deleted successfully")
        } else {
            toast.error(response?.payload?.message)
        }



    }



    // get by education by id
    const handleExperiencEditOpen = async (id) => {
        const data1 = {
            data: {},
            method: "get",
            apiName: `getExperienceById/${id}`,
        };
        const response = await dispatch(actions.GETEXPERIENCEBYID(data1));

        if (response?.payload?.message === "Experience fetched successfully.") {
            setExperienceEditData(response?.payload?.data)

            setUploadedFile(
                {
                    fileUrl: response?.payload?.data?.certificate_file,
                    type: "img", // ensure this is the expected type
                    progress: 100,
                }
            )
            handleExperienceModalOpen()


        }




    }

    //  delete by award by id

    const handleExericncedelete = async (id) => {

        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteExperience/${id}`,
        };
        const response = await dispatch(actions.DELETEEXPERIENCE(data1));
        console.log(response, "response")
        if (response?.payload?.message === "Experience deleted.") {
            toast.success("Experience deleted successfully")
        } else {
            toast.error(response?.payload?.message)
        }



    }

    // Experience


    const { createExperience } = useSelector(state => state?.createExperience);
    const { updateExperience } = useSelector(state => state?.updateExperience);
    const { deleteExperience } = useSelector(state => state?.deleteExperience);


    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getExperiencesByUserId/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETEXPERIENCEBYUSERID(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "Experiences fetched successfully.") {
                console.log("hiiiiiiiiiiiiiiii")

                const responseData = response?.payload?.data?.map((data) => ({
                    // user_id: data?.user_id,
                    id: data?.experience_id,
                    certificate_file: data?.certificate_file,

                    job_title: data?.job_title,
                    company_name: data?.company_name,
                    employment_type: data?.employment_type,
                    start_date: data?.start_date,
                    end_date: data?.end_date,
                    location: data?.location,
                    skills_used: data?.skills_used,
                    description: data?.description,
                    industry_category: data?.industry_category,






                }))
                setExperienceData(responseData)

            }
        }
        fetchData()


    }, [createExperience, updateExperience, deleteExperience])

    // --------------------------------------------------------------


    // get by project by id
    const handleProjectEditOpen = async (id) => {
        const data1 = {
            data: {},
            method: "get",
            apiName: `getProjectById/${id}`,
        };
        const response = await dispatch(actions.GETPROJECTBID(data1));

        if (response?.payload?.message === "Project fetched successfully.") {
            setProjectEditData(response?.payload?.data)

            setUploadedFile(
                {
                    fileUrl: response?.payload?.data?.certificate_file,
                    type: "img", // ensure this is the expected type
                    progress: 100,
                }
            )
            handleProjectnModalOpen()


        }




    }

    //  delete by award by id

    const handlePrjectdelete = async (id) => {

        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteProject/${id}`,
        };
        const response = await dispatch(actions.DELETPROJECT(data1));
        console.log(response, "response")
        if (response?.payload?.message === "Project deleted.") {
            toast.success("Project deleted successfully")
        } else {
            toast.error(response?.payload?.message)
        }



    }

    // projects


    const { createProject } = useSelector(state => state?.createProject);
    const { updateProject } = useSelector(state => state?.updateProject);
    const { deleteProject } = useSelector(state => state?.deleteProject);


    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getProjectsByUserId/user/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETPROJECTSBYUSERID(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "Projects fetched successfully.") {
                console.log("hiiiiiiiiiiiiiiii")

                const responseData = response?.payload?.data?.map((data) => ({
                    // user_id: data?.user_id,
                    id: data?.project_id,
                    certificate_file: data?.certificate_file,

                    project_title: data?.project_title,
                    role: data?.role,
                    description: data?.description,
                    start_date: data?.start_date ? new Date(data.start_date).toISOString().split('T')[0] : null,
                    end_date: data?.end_date ? new Date(data.end_date).toISOString().split('T')[0] : null,

                    skills: data?.skills,






                }))
                setProjectData(responseData)

            }
        }
        fetchData()


    }, [createProject, updateProject, deleteProject])



    // Skills
    const [skillsData, setSkillsData] = useState([])

    console.log(skillsData, "skillsData")
    const { updateUserStoreInfo } = useSelector(state => state?.updateUserStoreInfo);


    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserSkills/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETUSERSKILLS(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "getUserSkills fetched successfully.") {
                console.log("hiiiiiiiiiiiiiiii")

                // const responseData = response?.payload?.data?.map((data) => ({
                //     // user_id: data?.user_id,

                //      data,






                // }))
                setSkillsData(response?.payload?.data)

            }
        }
        fetchData()


    }, [updateUserStoreInfo])


    const { getUserById } = useSelector(state => state?.getUserById);
    const { editUserInfo } = useSelector(state => state?.editUserInfo);




    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserById/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETUSERBYID(data1));

            console.log(response, "responseresponse")


        }
        fetchData()


    }, [editUserInfo])


    const userInfoRows = [
        { label: 'Name', icon: FiUsers, value: `${getUserById?.data?.first_name} ${getUserById?.data?.last_name}` },
        { label: 'Gender', icon: IoMdTransgender, value: getUserById?.data?.gender },

        { label: 'Date of Birth', icon: MdOutlineDateRange, value: getUserById?.data?.date_of_birth ? new Date(getUserById?.data?.date_of_birth).toISOString().split('T')[0] : null },
        { label: 'Personal Email', icon: MdOutlineEmail, value: getUserById?.data?.personal_email },
        { label: 'Official Email', icon: MdOutlineEmail, value: getUserById?.data?.official_email },

        { label: 'Mobile', icon: IoCallOutline, value: getUserById?.data?.phone_no },
        { label: 'Present Address', icon: MdOutlineMyLocation, value: getUserById?.data?.present_address },

        { label: 'Present City', icon: MdOutlineAddLocation, value: getUserById?.data?.present_city },
        { label: 'Present State', icon: MdOutlineAddLocation, value: getUserById?.data?.present_state },
        { label: 'Present Country', icon: MdOutlineAddLocation, value: getUserById?.data?.present_country } || "--",

        { label: 'Permanent Address', icon: MdOutlineLocationOn, value: getUserById?.data?.permanentAddress },

        { label: 'Permanent City', icon: GrMapLocation, value: getUserById?.data?.permanentCity },
        { label: 'Year of Completion', icon: FaUserGraduate, value: getUserById?.data?.Year_of_completion },
        { label: 'Campus', icon: TiLocationArrowOutline, value: getUserById?.data?.campus },
        { label: 'Batch', icon: MdOutlineBatchPrediction, value: getUserById?.data?.batch },
        { label: 'Course', icon: SiAndroidstudio, value: getUserById?.data?.course },
        { label: 'Website', icon: CgWebsite, value: getUserById?.data?.website_url },
    ];






    const cygnusaEvents = [
        {
            heading: "Tech Fest: Innovators Ignite",
            date: "05/04/2023 - 30/04/2023",
            content: "Join us for a day of creativity and innovation at the annual Tech Fest, featuring coding competitions, workshops, and expert talks! 🚀"
        },
        {
            heading: "Cultural Carnival: Fusion Fiesta",
            date: "24/05/2023 - 24/05/2023",
            content: "Celebrate diversity with music, dance, and art at our vibrant Cultural Carnival. Unleash your talent and enjoy the magic of unity! 🎭🎶"
        },
        {
            heading: "Sports Extravaganza: Champions Unite",
            date: "01/06/2023 - 01/06/2023",
            content: "Gear up for adrenaline-pumping action at the Sports Extravaganza. Compete, cheer, and make memories on the field! 🏅⚽"
        },
    ]

    const awardEntries = [{
        title: 'LifeTime Achievement Award',
        subtitle: 'Education and Research',
        org: 'Avishkar Foundation',
        date: '2020'
    },
    {
        title: 'LifeTime Achievement Award',
        subtitle: 'Education and Research',
        org: 'Avishkar Foundation',
        date: '2020'
    }];

    const projectEntries = [{
        title: 'Workshop on Hand Embroidery to train 1000 members of cooperative societies',
        subtitle: 'Coordinator',
        org: 'Directorate of Hand looms and Textiles - Govt. of',
        date: '10.11.2010 to 31.12.2010'
    }];

    const { getUserStatsCount } = useSelector(
        (state) => state?.getUserStatsCount
    );

    useEffect(() => {

        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserStatsCount/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETUSERSTATUSCOUNT(data1));

        }
        fetchData()
    }, [])


    return (

        <Grid container spacing={2} sx={{
            backgroundColor: "rgb(245, 245, 245)",
            // minHeight: "1    00vh",
            pt: 3,
            px: {md:5,xs:3},
            width: "100%",
            pb: 3
        }}>
            <Grid item size={{ md: 3, xs: 12, sm: 12 }} sx={{

                borderRadius: "10px",
                // textAlign: "center",
                // p: 3,
                // maxHeight:"90vh"

            }}  >

                <Card sx={{ textAlign: "center", mb: 2 }}>
                    <CardContent>

                        <Box sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center"
                        }}>
                            <Avatar
                                src={`${adminUrl}${getUserById?.data?.profileImage}`}
                                sx={{
                                    // bgcolor: "white",
                                    border: "1px solid white",
                                    height: "200px", width: "80%",
                                    // "& .MuiAvatar-img": {
                                    //     objectFit: ""
                                    // }
                                }}
                            >
                            </Avatar>

                        </Box>

                        <Typography variant="h6" sx={{ mt: 2 }}>
                            {getUserById?.data?.first_name} {getUserById?.data?.last_name}
                        </Typography>
                        {/* <Typography mt={2} variant='h5'>
                            Professor
                        </Typography> */}
                        <Typography mb={3} variant='h5'>
                            {/* National Institute of Fashion Technology */}
                            {getUserById?.data?.course}
                        </Typography>
                        <Divider />
                        <Typography mt={2} sx={{
                            color: "#1976d2",
                            fontSize: "17px",
                            fontWeight: 700
                        }}>
                            {getUserStatsCount?.data?.connectionCount || 0}
                        </Typography>
                        <Typography mb={2}>
                            Connections
                        </Typography>
                        <Divider />
                        <Typography variant='body1' sx={{ mt: 2, cursor: "pointer" }} onClick={() => {
                            navigate("/")
                        }}>
                            Logout
                        </Typography>
                    </CardContent>
                </Card>
                {/* <ProjectsSection /> */}
                <ProjectsSection
                    handleImageClick={handleImageClick}
                    handleProjectEditOpen={handleProjectEditOpen} handlePrjectdelete={handlePrjectdelete} projectData={projectData} handleProjectnModalOpen={handleProjectnModalOpen} />
                <SkillsSection skillsData={skillsData} handleSKillsModalOpen={handleSKillsModalOpen} />

            </Grid>



            <Grid item size={{ md: 6, xs: 12, sm: 12 }} sx={{
                // backgroundColor: "white",
                borderRadius: "10px",

            }} >
                <Box sx={{
                    // backgroundColor:"white"
                }}>
                    {/* <NotificationAllmuiTab /> */}
                    <Card>
                        <CardContent>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography variant="h6" gutterBottom>
                                    Personal Details
                                </Typography>
                                <Typography variant='subtitle2' onClick={handleEditModalOpen} sx={{ cursor: "pointer" }}>
                                    <MdEdit /> Edit
                                </Typography>
                            </Box>


                            <InfoTable rows={userInfoRows} />

                        </CardContent>

                    </Card>
                </Box>

            </Grid>

            <Grid item size={{ md: 3, xs: 12, sm: 12 }} sx={{
                // backgroundColor: "white",
                // borderRadius: "10px",
                // p: 3

            }}>
                <AwardsSection
                    handleImageClick={handleImageClick}
                    title="Awards" icon={<EmojiEvents />} handleAwardelete={handleAwardelete} handleAwardEditOpen={handleAwardEditOpen} awards={awardData} handleModalOpen={handleAwardModalOpen} />


                {/* <AwardsSection title="Awards" icon={<EmojiEvents />} entries={awardEntries} handleModalOpen={handleAwardModalOpen} /> */}

                <EducationSection
                    handleImageClick={handleImageClick}
                    handleEducationEditOpen={handleEducationEditOpen} handleEducationdelete={handleEducationdelete} educationData={educationData} handleEducationModalOpen={handleEducationModalOpen} />

                <ExperienceSection
                    handleImageClick={handleImageClick}
                    handleExperiencEditOpen={handleExperiencEditOpen} handleExericncedelete={handleExericncedelete} experienceData={experienceData} handleExperienceModalOpen={handleExperienceModalOpen} />
                {/* <Box sx={{ p: 4 }}> */}
                {/* <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <AwardsSection title="Awards" icon={<EmojiEvents />} entries={awardEntries} handleModalOpen={handleAwardModalOpen} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <InfoCard title="Awards" icon={<EmojiEvents />} entries={awardEntries} handleModalOpen={handleAwardModalOpen} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InfoCard title="Projects" icon={<Folder />} entries={projectEntries} />
                    </Grid>
                </Grid> */}
                {/* </Box> */}

            </Grid>
            <EditProfileModal
                open={editModalOpen}
                onClose={handleEditModalClose}
            />
            <AwardCreateModal
                open={awardModalOpen}
                onClose={handleAwardModalClose}
                awardEditData={awardEditData}
                setAwardEditData={setAwardEditData}
            />

            <EducationCreateModal
                open={educationModalOpen}
                onClose={handleEducationModalClose}
                educationEditData={educationEditData}
                setEducationEditData={setEducationEditData}
                uploadedFile={uploadedFile}
                setUploadedFile={setUploadedFile}
            />
            <ExperienceCreateModal
                open={experienceModalOpen}
                onClose={handleExperienceModalClose}
                experienceEditData={experienceEditData}
                setExperienceEditData={setExperienceEditData}
                uploadedFile={uploadedFile}
                setUploadedFile={setUploadedFile}
            />
            <ProjectsCreateModal
                open={projectModalOpen}
                onClose={handleProjectModalClose}
                projectEditData={projectEditData}
                setProjectEditData={setProjectEditData}
                uploadedFile={uploadedFile}
                setUploadedFile={setUploadedFile}
            />

            <SkillsCreateModal
                open={skillsModalOpen}
                onClose={handleSkillsModalClose}
                skillsData={skillsData}
                setSkillsData={setSkillsData}

            />
            {/* Dialog for image preview */}
            {/* <Dialog open={previewOpen} onClose={handleClosePreview} maxWidth="md">
                <Box
                    component="img"
                    src={`${adminUrl}${previewImage}`}
                    alt="Certificate Preview"
                    sx={{ maxWidth: "600px", maxHeight: "400px" }}
                />
            </Dialog> */}
            <Dialog open={previewOpen} onClose={handleClosePreview} maxWidth="md">
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    Certificate Preview
                    <IconButton
                        aria-label="close"
                        onClick={handleClosePreview}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <IoCloseCircleOutline />
                    </IconButton>
                </DialogTitle>
                <Box
                    component="img"
                    src={`${adminUrl}${previewImage}`}
                    alt="Certificate Preview"
                    sx={{ maxWidth: "600px", maxHeight: "400px", mx: "auto", mb: 2 }}
                />
            </Dialog>




        </Grid>

    )
}

export default EditProfilePage